<template>
  <div>
    <generic-container
      :title="$t('apis')"
      icon="tools"
      :searchable="true"
      v-on:filter="filter"
      :show_refresh="true"
      @refresh="getData"
      :show_plus="true"
      @add="add"
      :header_buttons="header_buttons"
    >
      <!-- <h2 class="ui header">
        <i class="tools icon"></i>
        <div class="content">{{ $t("projects") }}</div>
      </h2> -->
      <div class="ui grid">
        <div class="three wide column">
          <div class="ui vertical fluid menu secondary pointing" ref="ttabs">
            <a
              class="item"
              :data-tab="item.uuid"
              v-for="(item, index) in apis_by_project"
              :key="index"
            >
              {{ item.name }}
            </a>
          </div>
        </div>
        <div class="thirteen wide stretched column">
          <div
            class="ui bottom attached tab segment"
            :data-tab="item.uuid"
            v-for="(item, index) in apis_by_project"
            :key="index"
          >
            <!-- <div class="ui four link cards">
              <div
                class="card"
                v-for="(api, idx) in item.apis"
                :key="idx"
                @click.stop="edit(api)"
              >
                <div class="content">
                  <div class="header">{{ api.name }}</div>
                  <div class="meta">
                    <span>{{ api.setup.general.url }}</span>
                  </div>
                  <div class="description">
                    <small>
                      <i
                        class="lock icon"
                        v-if="api.setup.security.authentication != 'none'"
                      ></i>
                      {{ $t("authentication") }}:
                      {{ $t(api.setup.security.authentication) }}
                    </small>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="ui selection list">
              <div
                class="item"
                v-for="(api, idx) in item.apis"
                :key="idx"
                @click.stop="edit(api)"
              >
                <img class="mini ui image" src="/images/icons/endpoint.png" />
                <div class="content" style="width:90%">
                  <div
                    class="ui mini basic right floated icon  button"
                    @click.stop="monit_endpoint(api)"
                    :data-tooltip="$t('monit')"
                  >
                    <i class="eye icon"></i>
                  </div>
                  <a class="header">{{ api.name }} </a>
                  <div class="description">
                    {{ api.setup.general.url }}
                  </div>
                  <div class="description">
                    <small>
                      <i
                        class="lock icon"
                        v-if="api.setup.security.authentication != 'none'"
                      ></i>
                      {{ $t("authentication") }}:
                      {{ $t(api.setup.security.authentication) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="ui three cards">
        <div
          class="card"
          v-for="(item, index) in apis_by_project"
          v-bind:key="index"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/project.jpg"
            />
            <div class="header">{{ item.name }}</div>
            <div class="meta">
              <span>{{ apis_number(item.apis) }}</span>
            </div>
            <div class="ui selection list">
              <div
                class="item"
                v-for="(api, idx) in item.apis"
                :key="idx"
                @click.stop="edit(api)"
              >
                <img class="mini ui image" src="/images/icons/endpoint.png" />
                <div class="content" style="width:90%">
                  <div
                    class="ui mini basic right floated icon  button"
                    @click.stop="monit_endpoint(api)"
                    :data-tooltip="$t('monit')"
                  >
                    <i class="eye icon"></i>
                  </div>
                  <a class="header">{{ api.name }} </a>
                  <div class="description">
                    {{ api.setup.general.url }}
                  </div>
                  <div class="description">
                    <small>
                      <i
                        class="lock icon"
                        v-if="api.setup.security.authentication != 'none'"
                      ></i>
                      {{ $t("authentication") }}:
                      {{ $t(api.setup.security.authentication) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </generic-container>

    <monitor
      v-show="show_monit"
      :endpoint="selected_endpoint"
      ref="monitor"
      @hide_monitor="hide_monitor"
    />
    <template v-for="(mdl, index) in endpoint_modals">
      <component
        :is="mdl"
        :key="index"
        :projects="projects"
        :endpoint_in="selected_endpoint"
        @succedded="succedded"
        @destroy="destroy"
        @deleted="deleted"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import EndpointModal from "./endpoint_modal/Index";
import Monitor from "./monitor/Monitor";
import { isEmpty, clone, groupBy } from "lodash";
import { v4 } from "uuid";

// @ is an alias to /src
export default {
  name: "APIList",
  components: {
    "generic-container": GenericContainer,
    Monitor,
  },
  filters: filters,
  data() {
    return {
      endpoints: [],
      header_buttons: [
        // {
        //   icon: "green plus",
        //   click: this.add_endpoint
        // }
      ],
      endpoint_modals: [],
      selected_endpoint: {},
      show_monit: false,
    };
  },
  computed: {
    apis_by_project() {
      let grps = groupBy(this.endpoints, function(endpt) {
        return endpt.setup.general.project;
      });

      let grouped = Object.keys(grps).map((k) => {
        return {
          name: k,
          uuid: v4(),
          apis: grps[k].sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            else return 0;
          }),
        };
      });

      return grouped.sort((a, b) => {
        if (a.name > b.name) return 1;
        else if (a.name < b.name) return -1;
        else return 0;
      });
    },
    projects() {
      let allProjects = this.endpoints.map((r) => {
        return r.setup.general.project;
      });
      return [...new Set(allProjects)];
    },
  },
  methods: {
    monit_endpoint(endpoint) {
      // console.log("monit+endpoint", endpoint);
      // if (this.selected_endpoint == endpoint) this.$refs.monitor.refresh();
      this.$refs.monitor.init_table(endpoint);
      this.selected_endpoint = endpoint;
      this.show_monit = true;
    },
    filter(value) {
      if (value == "") this.endpoints = this.all_endpoints;
      else
        this.endpoints = this.all_endpoints.filter((e) => {
          return (
            e.name.toUpperCase().includes(value.toUpperCase()) ||
            e.url.toUpperCase().includes(value.toUpperCase())
          );
        });
    },
    add() {
      this.endpoint_modals.push(EndpointModal);
    },
    edit(endpoint) {
      this.selected_endpoint = endpoint;
      this.endpoint_modals.push(EndpointModal);
    },
    succedded(endpoint) {
      let idx = this.endpoints.findIndex((e) => e.uuid == endpoint.uuid);
      if (idx >= 0) this.endpoints.splice(idx, 1, endpoint);
      else this.endpoints.push(endpoint);
      this.selected_endpoint = undefined;
    },
    destroy() {
      this.selected_endpoint = undefined;
      this.endpoint_modals = [];
    },
    isEmpty: isEmpty,
    apis_number(apis) {
      let lngth = apis.length;
      if (lngth == 1) return `${lngth} ${this.$i18n.t("api")}`;
      else if (lngth > 1) return `${lngth} ${this.$i18n.t("apis")}`;
      else return "¿?";
    },
    getData() {
      let vm = this;
      local_api(vm, "post", "/api_manager/do-get-endpoints")
        .then((endpoints) => {
          vm.endpoints = endpoints;
          vm.all_endpoints = clone(endpoints);

          setTimeout(() => {
            window
              .jQuery(vm.$refs.ttabs)
              .find(".item")
              .tab();
          }, 1000);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    deleted(p) {
      let idx = this.endpoints.findIndex((r) => r.uuid == p.uuid);
      if (idx >= 0) this.endpoints.splice(idx, 1);
      // this.destroy();
    },
    hide_monitor() {
      this.show_monit = false;
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
